import { isEmpty } from 'lodash';
import authConfig, { routerAuth } from 'config/authConfig';

const Nomatch = require('../routes/NoMatch/NoMatch');

const permission = {
  check(permissionName, AuthArray) {
    const allAuthArray = AuthArray || JSON.parse(sessionStorage.getItem('allAuthArray'));
    if (isEmpty(permissionName)) return true;
    const permissionObj = authConfig[permissionName];
    if (!permissionObj) return allAuthArray && allAuthArray.indexOf(permissionName) !== -1;
    switch (permissionObj.type) {
      case 1:
        return this.checkListType1(permissionObj.list, allAuthArray);
      case 2:
        return this.checkListType2(permissionObj.list, allAuthArray);
      case 3:
        return this.checkListType3(permissionObj.list, allAuthArray);
      default:
        return true;
    }
  },
  routerCheck(nextState) {
    const { routes, location, params } = nextState;
    let breadcrumb = '';
    let rightCode = '';
    routes.forEach(x => {
      breadcrumb += `${x.path}/`;
    });
    breadcrumb = breadcrumb.slice(2, breadcrumb.length - 1);
    const routObj = routerAuth[breadcrumb];
    if (!routObj) return true;
    if (typeof routObj === 'object') {
      if (routObj.type === 'params') {
        const val = params[routObj.field];
        rightCode = routObj.list[val];
      } else if (routObj.type === 'query') {
        const { query } = location;
        let action;
        if (!routObj.field) {
          action = !query.id ? 'add' : !query.type ? 'update' : 'view';
        } else {
          action = query[routObj.field];
        }
        rightCode = routObj.list[action];
      }
    } else {
      rightCode = routObj;
    }
    return permission.check(rightCode);
  },
  comCheck(comm, permissionName) {
    if (permission.check(permissionName)) {
      return comm;
    }
    return Nomatch;
  },
  checkListType1(list, allAuthArray) {
    if (!list.length) return true;
    return list.every(
      item => allAuthArray && allAuthArray.indexOf(item) !== -1
    );
  },
  checkListType2(list, allAuthArray) {
    if (!list.length) return true;
    return list.some(item => allAuthArray && allAuthArray.indexOf(item) !== -1);
  },
  checkListType3(list, allAuthArray) {
    if (!list.length) return true;
    return list.some(item => this.checkListType2(authConfig[item].list, allAuthArray));
  }
};

export default permission;
